(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["catalog-controls"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit',function(event){
  var form=event.target.closest('[data-coquin-filters]');
  if(!form)return;
  var min=form.querySelector('[name="filter.v.price.gte"]');
  var max=form.querySelector('[name="filter.v.price.lte"]');
  var error=form.querySelector('[data-filter-error]');
  if(min.value!==''&&max.value!==''&&Number(min.value)>Number(max.value)){
    event.preventDefault();error.hidden=false;min.focus();return;
  }
  error.hidden=true;
  form.action=form.querySelector('[data-catalog-category]').value;
  Array.from(form.elements).forEach(function(input){if(input.name&&input.value==='')input.disabled=true;});
});
  } catch(e) { console.error(e); }
})();

})();
